import { ReactNode } from 'react'

import { HeaderContainer } from './styles'

interface IHeaderProps {
  children: ReactNode
}

export function Header({ children }: IHeaderProps) {
  return <HeaderContainer>{children}</HeaderContainer>
}
